import { useContext } from 'react';

import { MioStateContext } from './mio-context';

export function useMio() {
  const ctx = useContext(MioStateContext);
  if (!ctx) throw new Error('useMio must be used inside MioProvider');
  return ctx;
}
